import './index.scss';
import AvatarList from 'Components/common/Avatar/List/List';
import Select from 'Components/common/Select/Select';
import React from 'react';

class SearchWorkstreamDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchIsLoading: false,
      searched: [],
      selected: null,
      isClose: false,
    };
  }

  searchWorkstreams = _.debounce(async (value) => {
    const { onSearchWorkstream } = this.props;

    const response = await onSearchWorkstream(value);

    if (response) {
      this.setState({
        ...this.state,
        searchIsLoading: false,
        searched: response.data.result.map((w) => {
          return {
            value: w.id,
            label: w.workstream,
            color: w.color,
            member: w.workstreamMembers.map((m) => ({ user: m })),
          };
        }),
      });
    }
  }, 400);

  handleOpenSelect = () => {
    this.searchWorkstreams();

    this.setState({ ...this.state, isClose: false, searchIsLoading: true });
  };

  handleSearch = (value) => {
    this.searchWorkstreams(value);
  };

  handleSelect = (value) => {
    if (this.props.onSelect) {
      this.props.onSelect(value);
      this.setState({ ...this.state, isClose: true });
    } else {
      this.setState({ ...this.state, selected: value });
    }
  };

  handleClearSelected = () => {
    this.setState({ ...this.state, selected: null, isClose: true });
  };

  handleTagWorkstream = () => {
    this.handleClearSelected();
  };

  render() {
    return (
      <div className="workstreamListContainer">
        <div className="workstreamListInput">
          <i className="material-icons searchIcon">search</i>
          <Select
            showSelectedInOptions={false}
            isSearchable={true}
            isLoading={this.state.searchIsLoading}
            classes={{ options: `tagFilesFilterOptions ${this.props.className}` }}
            placeholder="Search for Workstreams"
            options={this.state.searched}
            isClose={this.state.isClose}
            renderOption={(option) => (
              <div className="workstreamOption">
                <div className="workstreamName">
                  <div className="workstreamColor" style={{ backgroundColor: option.color }}></div>
                  <span>{option.label}</span>
                </div>
                <div className="workstreamDetails">
                  <AvatarList
                    idKey="user.id"
                    id={option.value}
                    avatars={option.member}
                    renderer={(m) => `${m.user.user.firstName} ${m.user.user.lastName}`}
                  />
                </div>
              </div>
            )}
            renderSelected={(option) => (
              <div className="workstreamOption">
                <div className="workstreamColor" style={{ backgroundColor: option.color }}></div>
                <span>{option.label}</span>
              </div>
            )}
            onOpen={this.handleOpenSelect}
            onSearch={this.handleSearch}
            onChange={this.handleSelect}
            onClearSelected={this.handleClearSelected}
            exclude={this.props.exclude ? this.props.exclude : []}
          />
        </div>
        {!this.props.disableButton && (
          <div className="tagWorkstreamBtnContainer">
            <button
              onClick={this.handleTagWorkstream}
              className={this.state.selected ? 'active' : ''}
            >
              Tag selected files
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default SearchWorkstreamDropdown;
